<div class="container-fluid">
	<div class="card p-3 my-3">
		<form (submit)="save()">
			<div *ngIf="item_stock_info">
				<div *ngIf="!requiresBatchInfo()">
					<div *ngFor="let store of store_list" class="row mt-1">
						<div class="col-6 col-md-6">{{store.id}} - {{store.name}}</div>
						<div class="col-6 col-md-2 form-group">
							<input class="form-control" [name]="'stock_recor'+store.id" type="number" [(ngModel)]="stock_record_dictionary[ store.id ].qty" required>
						</div>
					</div>
				</div>

				<div *ngIf="requiresBatchInfo()">
					<div *ngFor="let store of store_list" class="store-batch-section mb-4">
						<h6 class="store-batch-header">
							<span>{{store.id}} - {{store.name}}</span>
							<span class="badge bg-info" *ngIf="hasBatchesForStore(store.id)">Total: {{getStoreTotalQty(store.id)}}</span>
						</h6>

						<table class="table table-sm table-bordered batch-table" *ngIf="hasBatchesForStore(store.id)">
							<thead>
								<tr>
									<th *ngIf="requiresBatch()">Lote</th>
									<th *ngIf="requiresExpiration()">Caducidad</th>
									<th class="text-center">Qty Actual</th>
									<th class="text-center">Nueva Qty</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let row of getBatchRows(store.id)">
									<td *ngIf="requiresBatch()">{{row.batch}}</td>
									<td *ngIf="requiresExpiration()">{{row.expiration_date | date:'yyyy-MM-dd'}}</td>
									<td class="text-center">{{row.current_qty}}</td>
									<td class="text-center">
										<input type="number" class="form-control form-control-sm qty-input" [(ngModel)]="row.new_qty" [name]="'qty_'+store.id+'_'+row.batch" min="0">
									</td>
								</tr>
							</tbody>
						</table>

						<div *ngIf="!hasBatchesForStore(store.id)" class="no-batches-msg">
							No hay lotes/caducidades para esta tienda
						</div>

						<div class="new-batch-section mt-2">
							<div *ngFor="let newRow of newBatchRows[store.id]; let i = index" class="new-batch-row row g-2 mb-2">
								<div class="col" *ngIf="requiresBatch()">
									<input type="text" class="form-control form-control-sm" [(ngModel)]="newRow.batch" [name]="'new_batch_'+store.id+'_'+i" placeholder="Lote">
								</div>
								<div class="col" *ngIf="requiresExpiration()">
									<input type="date" class="form-control form-control-sm" [(ngModel)]="newRow.expiration_date" [name]="'new_exp_'+store.id+'_'+i">
								</div>
								<div class="col">
									<input type="number" class="form-control form-control-sm" [(ngModel)]="newRow.qty" [name]="'new_qty_'+store.id+'_'+i" placeholder="Cantidad">
								</div>
								<div class="col-auto">
									<button type="button" class="btn btn-sm btn-outline-danger" (click)="removeNewBatchRow(store.id, i)">
										<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/></svg>
									</button>
								</div>
							</div>
							<button type="button" class="btn btn-sm btn-outline-primary" (click)="addNewBatchRow(store.id)">
								<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/></svg>
								Agregar Lote
							</button>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-12 text-end">
						<button type="submit" class="btn btn-primary">
							<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.3em" height="1.3em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20"><path d="M15.173 2H4c-1.101 0-2 .9-2 2v12c0 1.1.899 2 2 2h12c1.101 0 2-.9 2-2V5.127L15.173 2zM14 8c0 .549-.45 1-1 1H7c-.55 0-1-.451-1-1V3h8v5zm-1-4h-2v4h2V4z" fill="currentColor"/></svg>
							Guardar
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>